var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserfilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.579 4.579 0 10 0C15.421 0 20 4.579 20 10C20 13.19 18.408 16.078 16 17.924V18H15.898C14.23 19.245 12.187 20 10 20C7.813 20 5.77 19.245 4.102 18H4V17.924C1.592 16.078 0 13.189 0 10ZM9 14.573C7.568 14.573 6.371 15.582 6.074 16.927C7.242 17.604 8.584 18 10 18C11.416 18 12.758 17.604 13.926 16.927C13.629 15.583 12.432 14.573 11 14.573H9ZM11 12.573C13.072 12.573 14.853 13.841 15.61 15.641C17.077 14.182 18 12.176 18 10C18 5.663 14.337 2 10 2C5.663 2 2 5.663 2 10C2 12.176 2.923 14.182 4.39 15.641C5.146 13.842 6.928 12.573 9 12.573H11ZM5.99995 7.99999C5.99995 5.71999 7.71995 3.99999 9.99995 3.99999C12.2799 3.99999 13.9999 5.71999 13.9999 7.99999C13.9999 10.28 12.2799 12 9.99995 12C7.71995 12 5.99995 10.28 5.99995 7.99999ZM7.99995 7.99999C7.99995 9.17799 8.82195 9.99999 9.99995 9.99999C11.1779 9.99999 11.9999 9.17799 11.9999 7.99999C11.9999 6.82199 11.1779 5.99999 9.99995 5.99999C8.82195 5.99999 7.99995 6.82199 7.99995 7.99999Z",
    fill: "#4E493F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserfilled);
export default __webpack_public_path__ + "static/media/userfilled.88b24ee1.svg";
export { ForwardRef as ReactComponent };